import InputRowGroup from "./Inputs/InputRowGroup";
import InputRow from "./Inputs/InputRow";
import DropdownInput from "./Inputs/DropdownInput";
import { handleChange } from "../Utils/DataCollectionUtils";
import React from "react";
import BooleanInput from "./Inputs/BooleanInput";
import { useTranslation } from "react-i18next";
import MultilineInputRow from "./Inputs/MultilineInputRow";
import TextInput from "./Inputs/TextInput";


const DRChecklist = ({ state }) => {
    const { t } = useTranslation();

    return (
        <form className={'dr-checklist'}>
            <InputRowGroup>
                <InputRow label={t('How did you meet the subscriber(s)?')}>
                    <DropdownInput
                        name={'howDidYouMeet'}
                        state={state.drChecklist}
                        onChange={handleChange(state.setDrChecklist)}
                        options={[
                            { value: 'Head office lead', label: t('Head office lead') },
                            { value: 'Existing subscriber', label: t('Existing subscriber') },
                            { value: 'Trade show/Advertisement', label: t('Trade show/Advertisement') },
                            { value: 'Through a friend/subscriber', label: t('Through a friend/subscriber') },
                            { value: 'Other', label: t('Other') },
                        ]}
                        useDefaultValue={false}
                        defaultPlaceholder={t('Select an option')}
                    />
                    {['Trade show/Advertisement', 'Through a friend/subscriber', 'Other'].includes(state.drChecklist.howDidYouMeet) &&

                        <TextInput
                            name={'howDidYouMeetDetails'}
                            state={state.drChecklist}
                            onChange={handleChange(state.setDrChecklist)}
                            maxLength={30}
                        />
                    }
                </InputRow>



                <InputRow label={t('Enrolment Application has been reviewed with the Subscriber(s) by the Dealing Representative')}>
                    <BooleanInput
                        name={'enrolmentApplicationReviewed'}
                        state={state.drChecklist}
                        onChange={handleChange(state.setDrChecklist)}
                    />
                </InputRow>

                <InputRow label={t('The most up to date version of the relevant CEFI plan presentation was presented by the undersigned DR in full.')}>
                    <BooleanInput
                        name={'cefiPlanPresentation'}
                        state={state.drChecklist}
                        onChange={handleChange(state.setDrChecklist)}
                    />
                </InputRow>

                <InputRow label={t('Subscriber(s) has received an explanation of each of the following boxes on the Enrolment Application by the Dealing Representative: receipt of prospectus; sales charge explanation; RESP contribution limit')}>
                    <BooleanInput
                        name={'enrolmentAppBoxesExplained'}
                        state={state.drChecklist}
                        onChange={handleChange(state.setDrChecklist)}
                    />
                </InputRow>

                <InputRow label={t('I have conducted a comprehensive Know Your Client discussion which is fully documented by the undersigned Dealing Representative using the appropriate KYC Form')}>
                    <BooleanInput
                        name={'kycDiscussion'}
                        state={state.drChecklist}
                        onChange={handleChange(state.setDrChecklist)}
                    />
                </InputRow>

                <InputRow label={t('The appropriate Plan Summary has been fully explained to the Subscriber(s) by the undersigned Dealing Representative.')}>
                    <BooleanInput
                        name={'planSummaryExplained'}
                        state={state.drChecklist}
                        onChange={handleChange(state.setDrChecklist)}
                    />
                </InputRow>

                <InputRow label={t('The Prospectus dated June 30, 2026 was delivered to Subscriber(s).')}>
                    <BooleanInput
                        name={'prospectusDelivered'}
                        state={state.drChecklist}
                        onChange={handleChange(state.setDrChecklist)}
                    />
                </InputRow>
                <InputRow label={t('The Relationship Disclosure Information Form was discussed with and explained to the Subscriber(s).')}>
                    <BooleanInput
                        name={'relationshipDisclosureExplained'}
                        state={state.drChecklist}
                        onChange={handleChange(state.setDrChecklist)}
                    />
                </InputRow>

                <InputRow label={t('The DR has physically inspected a valid form of identification as required and has inspected the SIN card/letter for the Subscriber(s) and Beneficiary for all SINs reported.')}>
                    <BooleanInput
                        name={'identificationInspected'}
                        state={state.drChecklist}
                        onChange={handleChange(state.setDrChecklist)}
                    />
                </InputRow>

                <InputRow label={t('Applications for Government Grants were discussed with and explained to the Subscriber(s).')}>
                    <BooleanInput
                        name={'grantApplicationsExplained'}
                        state={state.drChecklist}
                        onChange={handleChange(state.setDrChecklist)}
                    />
                </InputRow>

                <InputRow label={t('If applicable – Disclosure of Grant Limits for Subscriber(s) Exceeding Contributions of $2,500 Per Year was discussed with and explained to the Subscriber(s). NOTE: Dealing Representative must take into consideration existing commitments for Subscriber(s) to determine whether combined contributions will exceed $2,500 per year in respect of the SAME beneficiary. If so, Grant Limits Disclosure MUST accompany Enrolment.')}>
                    <BooleanInput
                        name={'grantLimitsExplained'}
                        state={state.drChecklist}
                        onChange={handleChange(state.setDrChecklist)}
                    />
                </InputRow>

                <InputRow label={t('If applicable – Non-Resident Risk Disclosure discussed with and explained to the a prospective Subscriber(s) applying for a Registered Education Savings Group Plan with a temporary Social Insurance Number issued by the Government of Canada. If so, Non-Resident Risk Disclosure MUST accompany Enrolment.')}>
                    <BooleanInput
                        name={'nonResidentRiskDisclosureExplained'}
                        state={state.drChecklist}
                        onChange={handleChange(state.setDrChecklist)}
                    />
                </InputRow>

                <InputRow label={t('If applicable – Disclosure of Third Party Financial Support – Where a prospective Subscriber(s) confirm(s) that they receive regular ongoing financial support from a third party (e.g. regular ongoing income or subsidized living expenses by reason of sharing accommodation (i.e. multi-generational living arrangement)). If so, a Disclosure of Third Party Financial Support Form (signed by the Financial Supporter) MUST accompany Enrolment.')}>
                    <BooleanInput
                        name={'thirdPartyFinancialSupportDisclosure'}
                        state={state.drChecklist}
                        onChange={handleChange(state.setDrChecklist)}
                    />
                </InputRow>

                <InputRow label={t('If applicable - Quebec Subscribers English only: I have provided the subscriber(s) a French version of the enrolment application for their consideration and review.')}>
                    <BooleanInput
                        name={'frenchEnrolmentApplicationProvided'}
                        state={state.drChecklist}
                        onChange={handleChange(state.setDrChecklist)}
                    />
                </InputRow>

                <InputRow label={t('If applicable – Dealing Representative 3rd Language Acknowledgment is completed & signed and dated by Dealing Representative when providing service or promoting the CET Plans to the Subscriber(s) in a language other than French or English.')}>
                    <BooleanInput
                        name={'thirdLanguageAcknowledgement'}
                        state={state.drChecklist}
                        onChange={handleChange(state.setDrChecklist)}
                    />
                </InputRow>

                <InputRow label={t('Escrow Agreement, if required, discussed with and explained to the discussed with and explained to the Subscriber(s).')}>
                    <BooleanInput
                        name={'escrowAgreementExplained'}
                        state={state.drChecklist}
                        onChange={handleChange(state.setDrChecklist)}
                    />
                </InputRow>

                <InputRow label={t('Any changes on forms have been initialed by the Subscriber(s).')}>
                    <BooleanInput
                        name={'changesInitialed'}
                        state={state.drChecklist}
                        onChange={handleChange(state.setDrChecklist)}
                    />
                </InputRow>

                <InputRow label={t('For deposits made by cheque, the cheque is payable to “CHILDREN’S EDUCATION TRUST OF CANADA”, signed and current dated. NOTE: Cheques payable to the Children’s Education Funds Inc. or any payee other than the Children’s Education Trust of Canada will be rejected.')}>
                    <BooleanInput
                        name={'chequePayableToCET'}
                        state={state.drChecklist}
                        onChange={handleChange(state.setDrChecklist)}
                    />
                </InputRow>

                <InputRow label={t('Any applicable Dual Licence or Outside Business Activity Disclosure(s) was fully discussed with and explained to the Subscriber(s).')}>
                    <BooleanInput
                        name={'dualLicenceDisclosureExplained'}
                        state={state.drChecklist}
                        onChange={handleChange(state.setDrChecklist)}
                    />
                </InputRow>

                <InputRow label={t('If insurance licensed: Optional Insurance form discussed with and explained to the Subscriber(s) in connection with the sale of optional insurance.')}>
                    <BooleanInput
                        name={'optionalInsuranceFormExplained'}
                        state={state.drChecklist}
                        onChange={handleChange(state.setDrChecklist)}
                    />
                </InputRow>
            </InputRowGroup>

            <InputRowGroup label={t('Non-Face-to-Face Enrolment – in addition to the items above, please confirm the following in the case of a Distance Enrolment')}>

            
            <InputRow label={t('I confirm that a digital copy of the June 30, 2026 Prospectus has been sent to the Subscriber as an attachment to the MS Teams invitation to the virtual Subscriber meeting.')}>
                    <BooleanInput
                        name={'cefiTeamsBackgroundUsed'}
                        state={state.drChecklist}
                        onChange={handleChange(state.setDrChecklist)}
                    />
                </InputRow>

                <InputRow label={t("I confirm that each prospective subscriber scanned: • their authentic, valid and current (not expired) government issued photo identification to me for my review via their mobile phone or device; and, • SIN card or letter for the Subscriber(s) and Beneficiary.")}>
                    <BooleanInput
                        name={'identificationScanned'}
                        state={state.drChecklist}
                        onChange={handleChange(state.setDrChecklist)}
                    />
                </InputRow>

                <InputRow label={t('I have duly recorded the identification number of the government issued photo identification and all SIN letters and cards that I inspected as required on the CEFI enrolment application in this manner. I have deleted the copy of the photo identification and SIN card/letter that I inspected in this manner.')}>
                    <BooleanInput
                        name={'identificationRecorded'}
                        state={state.drChecklist}
                        onChange={handleChange(state.setDrChecklist)}
                    />
                </InputRow>

                <InputRow label={t('I confirm that the photo identification presented to me as described above was inspected by me in accordance with CEFI’s Non-Face-to-Face Identification Verification policy.')}>
                    <BooleanInput
                        name={'identificationInspectedRemote'}
                        state={state.drChecklist}
                        onChange={handleChange(state.setDrChecklist)}
                    />
                </InputRow>

                <InputRow label={t('I engaged in a live videoconference with the subscriber(s) for the purpose of: A. Authenticating the name provided on the CEFI enrolment application by matching this name to the name provided on the digital copy of the government issued identification that I inspected; B. Authenticating the subscriber(s) facial image by matching their image to the photo provided on the digital copy of the government issued identification that I inspected; C. conducting this distance enrolment; and, D. delivering CEFI’s required plan presentation.')}>
                    <BooleanInput
                        name={'videoConferenceCompleted'}
                        state={state.drChecklist}
                        onChange={handleChange(state.setDrChecklist)}
                    />
                </InputRow>
            </InputRowGroup>

            <InputRowGroup label={t('Comments')}>
                <MultilineInputRow
                    name={'comments'}
                    state={state.drChecklist}
                    onChange={handleChange(state.setDrChecklist)}
                    maxLength={350}
                />
            </InputRowGroup>

        </form>
    )
}

export default DRChecklist;